export default __webpack_public_path__ + "static/media/report.f4458cf9.svg";